/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const OrderProfitabilityDTOProfitStateEnum = {
    Normal: 'NORMAL',
    Voided: 'VOIDED',
    Loss: 'LOSS',
    Refunded: 'REFUNDED'
};
/**
 * @export
 */
export const OrderProfitabilityDTOProductCostSourceEnum = {
    Extension: 'EXTENSION',
    Manual: 'MANUAL'
};
/**
 * Check if a given object implements the OrderProfitabilityDTO interface.
 */
export function instanceOfOrderProfitabilityDTO(value) {
    return true;
}
export function OrderProfitabilityDTOFromJSON(json) {
    return OrderProfitabilityDTOFromJSONTyped(json, false);
}
export function OrderProfitabilityDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'salePriceUsd': json['salePriceUsd'] == null ? undefined : json['salePriceUsd'],
        'salePriceOverridden': json['salePriceOverridden'] == null ? undefined : json['salePriceOverridden'],
        'salesTaxUsd': json['salesTaxUsd'] == null ? undefined : json['salesTaxUsd'],
        'salesTaxOverridden': json['salesTaxOverridden'] == null ? undefined : json['salesTaxOverridden'],
        'promotionUsd': json['promotionUsd'] == null ? undefined : json['promotionUsd'],
        'promotionOverridden': json['promotionOverridden'] == null ? undefined : json['promotionOverridden'],
        'productCostUsd': json['productCostUsd'] == null ? undefined : json['productCostUsd'],
        'productCostOverridden': json['productCostOverridden'] == null ? undefined : json['productCostOverridden'],
        'warehouseCostUsd': json['warehouseCostUsd'] == null ? undefined : json['warehouseCostUsd'],
        'warehouseCostOverridden': json['warehouseCostOverridden'] == null ? undefined : json['warehouseCostOverridden'],
        'referralFeeUsd': json['referralFeeUsd'] == null ? undefined : json['referralFeeUsd'],
        'referralFeeOverridden': json['referralFeeOverridden'] == null ? undefined : json['referralFeeOverridden'],
        'profitUsd': json['profitUsd'] == null ? undefined : json['profitUsd'],
        'profitPercent': json['profitPercent'] == null ? undefined : json['profitPercent'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'taxCollectionModel': json['taxCollectionModel'] == null ? undefined : json['taxCollectionModel'],
        'marketplaceCurrency': json['marketplaceCurrency'] == null ? undefined : json['marketplaceCurrency'],
        'currencyRate': json['currencyRate'] == null ? undefined : json['currencyRate'],
        'profitState': json['profitState'] == null ? undefined : json['profitState'],
        'refundedAt': json['refundedAt'] == null ? undefined : (new Date(json['refundedAt'])),
        'refundAmountUsd': json['refundAmountUsd'] == null ? undefined : json['refundAmountUsd'],
        'refundUsd': json['refundUsd'] == null ? undefined : json['refundUsd'],
        'refundOverridden': json['refundOverridden'] == null ? undefined : json['refundOverridden'],
        'giftCardUsd': json['giftCardUsd'] == null ? undefined : json['giftCardUsd'],
        'extraCostUsd': json['extraCostUsd'] == null ? undefined : json['extraCostUsd'],
        'couponUsd': json['couponUsd'] == null ? undefined : json['couponUsd'],
        'productCostTotalUsd': json['productCostTotalUsd'] == null ? undefined : json['productCostTotalUsd'],
        'netProceedsUsd': json['netProceedsUsd'] == null ? undefined : json['netProceedsUsd'],
        'totalCostUsd': json['totalCostUsd'] == null ? undefined : json['totalCostUsd'],
        'productCostSource': json['productCostSource'] == null ? undefined : json['productCostSource'],
        'eurRate': json['eurRate'] == null ? undefined : json['eurRate'],
        'currencyRateLive': json['currencyRateLive'] == null ? undefined : json['currencyRateLive'],
    };
}
export function OrderProfitabilityDTOToJSON(json) {
    return OrderProfitabilityDTOToJSONTyped(json, false);
}
export function OrderProfitabilityDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'salePriceUsd': value['salePriceUsd'],
        'salePriceOverridden': value['salePriceOverridden'],
        'salesTaxUsd': value['salesTaxUsd'],
        'salesTaxOverridden': value['salesTaxOverridden'],
        'promotionUsd': value['promotionUsd'],
        'promotionOverridden': value['promotionOverridden'],
        'productCostUsd': value['productCostUsd'],
        'productCostOverridden': value['productCostOverridden'],
        'warehouseCostUsd': value['warehouseCostUsd'],
        'warehouseCostOverridden': value['warehouseCostOverridden'],
        'referralFeeUsd': value['referralFeeUsd'],
        'referralFeeOverridden': value['referralFeeOverridden'],
        'profitUsd': value['profitUsd'],
        'profitPercent': value['profitPercent'],
        'currency': value['currency'],
        'taxCollectionModel': value['taxCollectionModel'],
        'marketplaceCurrency': value['marketplaceCurrency'],
        'currencyRate': value['currencyRate'],
        'profitState': value['profitState'],
        'refundedAt': value['refundedAt'] == null ? undefined : ((value['refundedAt']).toISOString()),
        'refundAmountUsd': value['refundAmountUsd'],
        'refundUsd': value['refundUsd'],
        'refundOverridden': value['refundOverridden'],
        'giftCardUsd': value['giftCardUsd'],
        'extraCostUsd': value['extraCostUsd'],
        'couponUsd': value['couponUsd'],
        'productCostTotalUsd': value['productCostTotalUsd'],
        'netProceedsUsd': value['netProceedsUsd'],
        'totalCostUsd': value['totalCostUsd'],
        'productCostSource': value['productCostSource'],
        'eurRate': value['eurRate'],
        'currencyRateLive': value['currencyRateLive'],
    };
}
